import { Form, Select, Button, message, Modal } from "antd";
import { useEffect } from "react";
import axios from "axios";

const { Option } = Select;

const opcionesEdificio = [
  "Oficinas",
  "Escuelas o instituciones educativas",
  "Bibliotecas",
  "Tiendas de autoservicio, departamentales y de especialidades",
  "Hospitales, Sanatorios y Clínicas",
  "Hoteles",
  "Moteles",
  "Restaurantes",
  "Cafeterías y venta de comida rápida",
  "Bares",
  "Bodegas y áreas de almacenamiento",
  "Salas de cine",
  "Teatros y auditorios",
  "Centros de convenciones",
  "Gimnasio y centros deportivos",
  "Museos",
  "Templos",
  "Talleres de servicio para automóviles",
  "Talleres de detalle, eléctricos, de ensamble, de pintura no automotriz.",
  "Centrales y terminales de transporte de carga",
  "Centrales y terminales de transporte de pasajeros, aéreo y terrestre",
];

export default function Nom007TipoEdificioForm(props) {
  const { visible, title, mainData: verification, setMainData: setVerification, setVisible } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (verification) {
      form.setFieldsValue(verification);
    }
  }, [verification, form]);

  const onFinish = (values) => {
    const verificationData = {
      ...verification,
      ...values,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification.VerificacionID}`, verificationData)
      .then(() => {
        message.success("Campos actualizados correctamente");
        setVerification(verificationData);
        setVisible(false);
      })
      .catch((err) => {
        console.log(err);
        message.error("Error al actualizar los campos");
      });
  };

  return (
    <Modal title={title} visible={visible} onCancel={() => setVisible(false)} footer={null} width={800} centered>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="TipoEdificio" label="Tipo de Edificio">
          <Select>
            {opcionesEdificio.map((opcion) => (
              <Option key={opcion} value={opcion}>
                {opcion}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Button type="primary" htmlType="submit">
          Guardar
        </Button>
      </Form>
    </Modal>
  );
}
